import Vue from 'vue';
import Vuex from 'vuex';
import VuexPersist from 'vuex-persist';
import createLogger from 'vuex/dist/logger';

import auth from './store_config/auth';
import password from './store_config/password';
import signup from './store_config/signup';
import whoami from './store_config/whoami';
import getpdf from './store_config/getpdf';
import preview from './store_config/preview';
import sidebar from './store_config/sidebar';
import sidebarLanding from './store_config/sidebarLanding';
import sectionLayout from './store_config/sectionLayout';
import loading from './store_config/loading.js';
import cvVuex from './store_config/cvVuex';

const debug = process.env.NODE_ENV !== 'production';

const vuexPersist = new VuexPersist({
  key: 'my-app',
  storage: localStorage
});


Vue.use(Vuex);

export default new Vuex.Store({
  modules: {
    auth,
    password,
    signup,
    whoami,
    getpdf,
    preview,
    sidebar,
    sidebarLanding,
    sectionLayout,
    loading,
    cvVuex,
  },
  strict: debug,
  // plugins: debug ? [createLogger()] : [],
  plugins: [vuexPersist.plugin],
});
